import React, { useEffect, useState } from 'react'
import SupplyBillAgreeIco from '../../../../supplyBill/view/items/SupplyBillAgreeIco'
import { Tooltip } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveIcon from '@mui/icons-material/Remove';

const SupplyOrderItemsAgreeCount = ({ supplyOrderItems }) => {

    const [countAgree, setCountAgree] = useState(0)
    const [countDisagree, setCountDisagree] = useState(0)
    const [countOther, setCountOther] = useState(0)

    useEffect(() => {
        changeCount()
    }, [supplyOrderItems])

    const changeCount = () => {
        if (supplyOrderItems && supplyOrderItems.length > 0) {
            let countAgreeTemp = 0, countDisagreeTemp = 0, countOtherTemp = 0
            for (const item of supplyOrderItems) {
                if (item.isAgreeDirector === true) {
                    countAgreeTemp += 1
                } else if (item.isAgreeDirector === false) {
                    countDisagreeTemp += 1
                } else {
                    countOtherTemp += 1
                }
            }

            setCountAgree(countAgreeTemp)
            setCountDisagree(countDisagreeTemp)
            setCountOther(countOtherTemp)
        } else {
            setCountAgree(0)
            setCountDisagree(0)
            setCountOther(0)
        }
    }

  return (
    <div className='supplyAgrees__column'>
        <p className={`supplyAgrees__agree `}>
            <Tooltip title='Погоджено директором'>
                <AddCircleOutlineIcon />
            </Tooltip>
            {countAgree}
        </p>
        <p className={`supplyAgrees__disagree`}>
            <Tooltip title={`Не погоджено директором`}>
                <RemoveCircleIcon />
            </Tooltip>
            {countDisagree}
        </p>
        <p className={`supplyAgrees__approval`}>
            <Tooltip title='Очікує погодженння директором'>
                <RemoveIcon />
            </Tooltip>
            {countOther}
        </p>
    </div>
  )
}

export default SupplyOrderItemsAgreeCount